import React from "react";
import PromoCategory from "./PromoCategory";
import cn from "classnames";
import { ImageType, ProductImageTypes, Promo, PromoSection } from "@core/types";
import { usePromoSection } from "../../hooks/usePromoSection";

type PromoCategoriesProps = PromoSection;

const PromoCategories = ({ ...promoSectionProps }: PromoCategoriesProps) => {
  const { promos, handlePromoClick } = usePromoSection(promoSectionProps);
  const totalItems = promos.length;

  if (!totalItems) return null;

  return (
    <div className="grid grid-cols-6 gap-3">
      {promos?.map((promo, index) => {
        const promoImage = { ...promo.images[0], type: ProductImageTypes.img } as ImageType;
        const isLastSingle = totalItems % 3 === 1 && index === totalItems - 1;
        const isLastDouble = totalItems % 3 === 2 && index >= totalItems - 2;

        return (
          <PromoCategory
            promo={promo}
            key={promo.id}
            isLastSingle={isLastSingle}
            promoImage={promoImage}
            onClick={() => handlePromoClick(promo)}
            className={cn("col-span-2", {
              "col-span-6": isLastSingle,
              "col-span-3": isLastDouble,
            })}
          />
        );
      })}
    </div>
  );
};

export default PromoCategories;
